import { Typography } from '@mui/material';

interface ErrorMessageProps {
    error: Error | null;
}

const errorMessage = 'Sorry, something went wrong.';

const ErrorMessage = ({ error }: ErrorMessageProps) => (
    <Typography variant='body2'>{`${errorMessage} ${error?.message}`}</Typography>
);

export default ErrorMessage;
